import { getTemplateByIdCallback } from 'Pages/Campaign/recoil/callbacks/callbacks'
import { editorState } from 'Pages/Campaign/recoil/state/bee'
import { campaignState } from 'Pages/Campaign/recoil/state/campaign'
import { previewState } from 'Pages/Campaign/recoil/state/preview'
import { useEffect } from 'react'
import { useRecoilCallback, useRecoilValue } from 'recoil'
import BeePluginEditor from './BeePluginEditor'
import { HeaderEditMessage } from './HeaderEditMessage'
import Preview from './Preview'

export const EditMessage = () => {
  const { initialStructure } = useRecoilValue(editorState)
  const { active: previewActive } = useRecoilValue(previewState)
  const {
    EmailOptions: { IdTemplate }
  } = useRecoilValue(campaignState)

  const getTemplateById = useRecoilCallback(getTemplateByIdCallback, [])

  useEffect(() => {
    IdTemplate && IdTemplate >= 0 && getTemplateById()
  }, [IdTemplate])

  return (
    <>
      <HeaderEditMessage />

      <div style={!previewActive ? { display: 'none' } : undefined}>
        <Preview />
      </div>

      <div style={previewActive ? { display: 'none' } : undefined}>
        {initialStructure && <BeePluginEditor />}
      </div>
    </>
  )
}
